import { EnumBaseType } from 'src/app/shared/types/enum-base.type';
import { Util } from '../../shared/utils/util';

export class EnumBase<T extends EnumBaseType = EnumBaseType> {

    private enum: T[];

    constructor(enumParam: T[]) {
        this.enum = enumParam;
    }

    getAll(): T[] {
        return this.enum;
    }

    getAllForSelect(): T[] {
        const list = [...this.enum];
        list.unshift(({ name: 'Selecione...', value: '' } as T));
        return list;
    }

    getById(value: string): T {
        return this.enum.find((item: T) => item.value === value);
    }

    getValue(name: string) {
        const result = this.enum.find((item: T) => item.name === name);
        return result ? result.value : null;
    }

    getName(value: string) {
        const result = this.enum.find((item: T) => item.value === value);
        return result ? result.name : null;
    }

  getAllOrderByName() {
      return Util.sortList(this.getAll());
  }

}
